import { Identifiable, Resource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function assignManagerToResource(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>, manager: Identifiable<Resource>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/resources/${resource.uuid}/managers`,
      method: HttpMethods.POST,
      data: [manager.uuid],
    });
}

export { assignManagerToResource };
